module.exports = "<div class=\"col-12 text-center padd \" *ngIf=\"timer\">\r\n    <span class=\"counter\" *ngIf=\"timeInSeconds && timeInSeconds > 0\">\r\n    <img class=\"counterimg\" src=\"../../../../assets/images/img/timer.png\">\r\n    <mwl-gauge [max]=\"timeInSeconds\" [dialStartAngle]=\"-90\" [dialEndAngle]=\"-90.001\" [label]=\"getSecondsAsDigitalClock\" [value]=\"countDown | async\" [animated]=\"true\" [animationDuration]=\"1\">\r\n    </mwl-gauge>\r\n    </span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/stage/components/count-down-timer/count-down-timer.component.html
// module id = ./src/app/stage/components/count-down-timer/count-down-timer.component.html
// module chunks = main